import React from "react";

import { BonusPobjednici } from '../../Layout/BonusPobjednici.jsx'

export class SsoplBody extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            tabs: ['Raspored', 'Nagrade', 'Bodovi', 'Rezultati'],
            selectedTab: null,
            tuniri: null,
            showTurnir: null,
            turnirPobjednici: null
        }


        this.gotoTab = this.gotoTab.bind(this);
        this.getBody = this.getBody.bind(this);
        this.showTurnirRezultati = this.showTurnirRezultati.bind(this);
        this.fetchData = this.fetchData.bind(this);
        this.fetchTurnirRezultatiData = this.fetchTurnirRezultatiData.bind(this);
        this.setData = this.setData.bind(this);
        this.setTurnirPobjediniciData = this.setTurnirPobjediniciData.bind(this);

        casino.utils.createPageGoogleTagManagerEvent('Bonusi', 'SSOPL', 'poker', this.props.user);

    }


    showTurnirRezultati(turnir) {
        this.setState({
            showTurnir: turnir,
            turnirPobjednici: null
        });

        this.fetchTurnirRezultatiData(turnir);
    }
    componentDidMount() {
        this.gotoTab(this.state.tabs[0]);
        this.fetchData();
    }
    fetchData() {
        this.props.showLoadingFn(true);

        var promises = Promise.all([casino.repos.pokerSSOPLTurniriRepo.list()]);

        this.dataPromises = casino.utils.makeCancelablePromise(promises);
        this.dataPromises.promise.then(this.setData, function (reason) { });
    }

    fetchTurnirRezultatiData(turnir) {
        this.props.showLoadingFn(true);

        var promises = Promise.all([casino.repos.pokerSSPOLTurnirPobjedniciRepo.list(turnir)]);

        this.dataPromises = casino.utils.makeCancelablePromise(promises);
        this.dataPromises.promise.then(this.setTurnirPobjediniciData, function (reason) { });
    }
    componentWillUnmount() {
        if (this.dataPromises)
            this.dataPromises.cancel();
    }
    setData(data) {
        var [turniri] = data;

        this.setState({
            turniri: turniri
        });

        this.props.showLoadingFn(false);
    }
    setTurnirPobjediniciData(data) {
        var [pobjedinici] = data;

        this.setState({
            turnirPobjednici: pobjedinici
        });

        this.props.showLoadingFn(false);
    }
    gotoTab(tab) {
        this.setState({ selectedTab: tab });
    }
    getBody() {
        if (this.state.selectedTab == 'Raspored') {
            return <div>
                <div className="padding-sides-medium-2">
                    <h2 className="v3">{this.state.selectedTab}</h2>
                    Turnire potražite u SupersSport poker aplikaciji i u tablici u nastavku.
                <br /><br />
                </div>
                <div>
                    {!this.state.turniri && <div>Dohvaćanje turnira...</div>}
                    {this.state.turniri &&
                        <div>
                            <table className="table-1 v2 v3">
                                <thead>
                                    <tr>
                                        <th className="text-left text text-6">Buy-in</th>
                                        <th className="text-left text text-6">Turnir</th>
                                        <th className="text-left text text-6">Vrijeme</th>
                                        <th className="text-center text text-6">Rezultati</th>
                                    </tr>
                                </thead>
                                <tbody>

                                    {this.state.turniri.map((turnir) => {
                                        var datum = new Date(turnir.datum);
                                        return <tr className="horizontal-lines" key={turnir.datum}>

                                            <td className="text-left text text-7 nowrap">{casino.utils.numberWithCurrencyFromated(turnir.buyIn/7.5345, 'EUR')}</td>
                                            <td className="text text-1">
                                                <span>{turnir.naziv}</span>
                                            </td>
                                            <td>
                                                <span className="text text-1">{casino.utils.dateToTimeString(datum)}</span><br />
                                                <span className="text text-2">
                                                    {datum.getDate() + '.' + (datum.getMonth() + 1) + '.' + datum.getFullYear().toString().slice(2) + "."}
                                                </span>
                                            </td>
                                            <td className="text text-1 text-large text-center">
                                                <a className="as-link" onClick={(e) =>{ e.preventDefault();this.showTurnirRezultati(turnir)}}>
                                                    <span className="icon ico-search color-gray"></span>
                                                </a>
                                            </td>
                                        </tr>
                                    }
                                    )}


                                </tbody>
                            </table>
                        </div>
                    }
                </div>



                <div className={"modal-dialog-overlay" + (this.state.showTurnir != null ? ' active' : '')}>
                    <div className="modal-dialog--inner flex-column">


                        <div className="modal-dialog-header clearfix">
                            <div className="modal-dialog--name">
                                <span className="naziv">{this.state.showTurnir && this.state.showTurnir.naziv}</span>
                            </div>
                            <a className="active pull-right as-link link link-1" onClick={(e) => {e.preventDefault(); this.setState({ showTurnir: null })}}>
                                <span className="close-icon icon ico-close-thin"></span>
                            </a>
                        </div>

                        <div className="modal-dialog-container flex-1">
                            <div className="modal-dialog-container--inner flex-equal-size">
                                <div>
                                    <div className="relative">


                                        <div>
                                            <table className="table-1 v2">
                                                <thead>
                                                    <tr>
                                                        <th className="text-left text text-6">Alias</th>
                                                        <th className="text-center text text-6">Broj bodova</th>
                                                        <th className="text-right text text-6">Dobitak</th>
                                                    </tr>
                                                </thead>
                                                <tbody>

                                                    {!this.state.turnirPobjednici && <tr className="horizontal-lines"><td colSpan="3" className="text text-1">Dohvaćanje pobjednika...</td></tr>}

                                                    {this.state.turnirPobjednici && !this.state.turnirPobjednici.length && <tr className="horizontal-lines"><td colSpan="3" className="text text-1">Trenutno nema rezultata...</td></tr>}


                                                    {this.state.turnirPobjednici && this.state.turnirPobjednici.map((igrac) => {

                                                        return <tr className="horizontal-lines" key={igrac.alias}>
                                                            <td className="text text-1">
                                                                <span>{igrac.alias}</span>
                                                            </td>
                                                            <td className="text text-center text-1">
                                                                <span>{igrac.bodova}</span>
                                                            </td>
                                                            <td className="text-right text text-7 nowrap">{casino.utils.numberWithCurrencyFromated(igrac.dobitak/7.5345 , 'EUR')}</td>
                                                        </tr>
                                                    })}



                                                </tbody>
                                            </table>
                                        </div>



                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        }

        if (this.state.selectedTab == 'Nagrade') {
            return (<div>
                <div className="padding-sides-medium-2">
                    <h2 className="v3">{this.state.selectedTab}</h2>
                    <div>
                        Najbolji Poker igrači osvajaju super nagrade!  Svaki  nastup će se posebno bodovati, svi igrači koji pređu prag od 20.000 bodova će sudjelovati u završnom pozivnom turniru GTD 3.981,68 €, a dodatno  prvih 20 igrača lige osvaja novčane nagrade. <br />
                        Nagrade za najbolje igrače SuperSport Online Poker Lige, Nova godina 2022.<br /> <br />

                    </div>
                </div>
                <table className="table-1 v2">
                    <thead>
                        <tr>
                            <th className="text-left text text-6">Plasman</th>
                            <th className="text-left text text-6">Nagrada</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr className="horizontal-lines">
                            <td className="text text-1 nowrap">1. Mjesto</td>
                            <td className="text text-1">929,06 €</td>
                        </tr>
                        <tr className="horizontal-lines">
                            <td className="text text-1 nowrap">2. Mjesto</td>
                            <td className="text text-1">663,61 €</td>
                        </tr>
                        <tr className="horizontal-lines">
                            <td className="text text-1 nowrap">3. Mjesto</td>
                            <td className="text text-1">331,80 €</td>
                        </tr>
                        <tr className="horizontal-lines">
                            <td className="text text-1 nowrap">4. i 5. Mjesto</td>
                            <td className="text text-1">132,72 €</td>
                        </tr>
                        <tr className="horizontal-lines">
                            <td className="text text-1 nowrap">6. do 10. Mjesto</td>
                            <td className="text text-1">66,36 €</td>
                        </tr>
                        <tr className="horizontal-lines">
                            <td className="text text-1 nowrap">11. do 10. Mjesto</td>
                            <td className="text text-1">13,27 €</td>
                        </tr>
                        {/* <tr className="horizontal-lines">
                            <td className="text text-1  nowrap">2. Mjesto</td>
                            <td className="text text-1">Ulaznica za Supersport 50 000€ GTD u vrijednosti od 220€ i 500kn</td>
                        </tr>
                        <tr className="horizontal-lines">
                            <td className="text text-1  nowrap">3. Mjesto</td>
                            <td className="text text-1">Ulaznica za Supersport 50 000€ GTD u vrijednosti od 220€ i 300kn</td>
                        </tr>
                        <tr className="horizontal-lines">
                            <td className="text text-1 nowrap">4. - 20. Mjesto</td>
                            <td className="text text-1">Ulaznica za Supersport 50 000€ GTD u vrijednosti od 220€</td>
                        </tr> */}

                    </tbody>
                </table>
            </div>)
        }

        if (this.state.selectedTab == 'Bodovi') {

            return <div className="padding-sides-medium-2">
                <h2 className="v3">{this.state.selectedTab}</h2>
                <div>
                    Svaki od igrača koji osvoji više od 20.000 bodova osvaja pozivnicu za završni turnir SSOPL Lige GTD 3.981,68 €.<br /><br />

                    Ukoliko 30 igrača ne uspije osvojiti 20.000 bodova, razlika će se upotpuniti sa najboljim igračima iz leaderboarda ako prag ne pređe 30 igrača. Top 30 igrača po poretku iz Lige će sudjelovati u završnom turniru.<br /><br />
                    Bodovi u SSOPL-u se dodjeljuju po slijedećoj formuli:
                        <br /><br />
                    <div className="max-width-40">
                        <img src="content/images/poker/bonusi/formula_2025.png" />
                    </div>
                    <ul>
                        <li className="text text-2">b = Broj natjecatelja u turniru + broj re-rentrya</li>
                        <li className="text text-2">u = Trošak ulaznice (buy-in) za turnir</li>
                        <li className="text text-2">p = Pojedinačni plasman igrača na turniru</li>
                    </ul>
                    <br />
                        U slučaju izjednačenog broja bodova gleda se ukupno osvojena svota novaca na SSOPL turnirima.
                    </div>
            </div>
        }


        if (this.state.selectedTab == 'Rezultati') {
            return <div>
                <h2 className="v3 padding-sides-medium-2">{this.state.selectedTab}</h2>
                <BonusPobjednici {...this.props} />
            </div>
        }
    }

    render() {
        return <div>
            <div className="segment v2 margin-top-small padding-sides-medium-2">
                {this.state.tabs && this.state.tabs.map((tab) =>
                    <button key={tab} onClick={() => this.gotoTab(tab)} className={'segment--btn' + (this.state.selectedTab === tab ? ' selected' : '')}><span>{tab}</span></button>
                )}
            </div>
            {this.getBody()}
        </div>
    }
};
